import { useToast, Text, VStack } from '@chakra-ui/react'
import { useCallback } from 'react'
import { formatErrorForToast } from './errorHandler'

export function useToastNotification() {
  const toast = useToast()

  const showError = useCallback(
    (error: any) => {
      const errorInfo = formatErrorForToast(error)

      const renderDescription = () => {
        if (errorInfo.errors && errorInfo.errors.length > 0) {
          return (
            <VStack align="stretch" spacing={1} mt={1}>
              {errorInfo.errors.map((msg, idx) => (
                <Text key={idx} fontSize="sm">
                  • {msg}
                </Text>
              ))}
            </VStack>
          )
        }
        return errorInfo.description
      }

      toast({
        title: errorInfo.title || 'Error',
        description: renderDescription(),
        status: 'error',
        variant: 'left-accent',
        position: 'top-right',
        duration: 6000,
        isClosable: true,

        // 🎨 Figma colors
        containerStyle: {
          background: '#FEF1F1',
        },
      })
    },
    [toast],
  )

  const showSuccess = useCallback(
    (message: string, description?: string) => {
      toast({
        title: message,
        description,
        status: 'success',
        variant: 'left-accent',
        position: 'top-right',
        duration: 5000,
        isClosable: true,

        // 🎨 Figma colors
        containerStyle: {
          background: '#DDFBE5',
        },
      })
    },
    [toast],
  )

  const showWarning = useCallback(
    (message: string, description?: string) => {
      toast({
        title: message,
        description,
        status: 'warning',
        variant: 'left-accent',
        position: 'top-right',
        duration: 5000,
        isClosable: true,
      })
    },
    [toast],
  )

  const showInfo = useCallback(
    (message: string, description?: string) => {
      toast({
        title: message,
        description,
        status: 'info',
        variant: 'left-accent',
        position: 'top-right',
        duration: 5000,
        isClosable: true,
      })
    },
    [toast],
  )

  return {
    showError,
    showSuccess,
    showWarning,
    showInfo,
    toast,
  }
}